import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { NoIndex } from '../../components/Seo';
import { localizedPath } from '../../i18n/config';
import { useLocale } from '../../i18n/useLocale';

export function NotFoundPage() {
  const { t } = useTranslation();
  const locale = useLocale();

  return (
    <div className="container page-head not-found">
      <NoIndex title={t('meta.notFoundTitle')} />
      <h1>{t('notFound.title')}</h1>
      <p className="lead">{t('notFound.text')}</p>
      <Link className="button button-secondary" to={localizedPath(locale, '/')}>
        {t('notFound.backHome')}
      </Link>
    </div>
  );
}
